module.exports = __webpack_public_path__ + "media/images/cms/img_slide_02-4dd78b708bb72c34ff6a9240a8ffa3a6.jpg";